import React from "react";
import { Link } from "react-router-dom";
import classes from "./checkout-form.module.scss";

function OrderStatus({ OrderResponse }) {
  if (!OrderResponse) return null;

  return (
    <div className={classes.orderStatusWrap}>
      <div className={classes.orderStatusCard}>
        <div className={classes.orderStatusIcon}>
          <svg viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg" width="64" height="64">
            <circle cx="26" cy="26" r="26" fill="#2e7d32" />
            <path d="M15 27l7 7 15-15" stroke="#fff" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
        <h2 className={classes.orderStatusTitle}>Thank You For The Purchase !</h2>
        <p className={classes.orderStatusText}>Confirmation Mail Has Been Sent To Your Mail Id</p>
        <p className={classes.orderStatusText}>We Hope You Enjoy Your Purchase</p>
        <Link
          to={`${process.env.PUBLIC_URL}/jewellery`}
          className={classes.orderStatusBtn}
        >
          Continue Shopping
        </Link>
      </div>
    </div>
  );
}

export default OrderStatus;
